import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#101a12] px-5 py-16" data-id="element-273" data-mp="2skdw96yru3g7">
      <div className="mx-auto max-w-2xl border-2 border-emerald-400 bg-[#1b2b1e] p-8 text-center sm:p-11" data-id="element-274" data-mp="36ahd1ievt4y9">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-275" data-mp="31izaipx7mwb6">
          <Clock3Icon className="h-4 w-4" data-id="element-276" data-mp="3g72ejtrozxxc" />
          Offerta a tempo limitato
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-277" data-mp="3b7zbgev9w1s0">
          Il prezzo di lancio scade tra:
        </h2>
        <div className="my-9" data-id="element-278" data-mp="3l78dzw47eopz">
          <CountdownTimer size="large" dark data-id="element-279" data-mp="3l6ynm7f8yfjr" />
        </div>
        <p className="font-semibold text-white" data-id="element-280" data-mp="3l5du8l4o52nh">
          Dopo, il prezzo aumenterà e i bonus potrebbero non essere più inclusi.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-281" data-mp="1qtyxhkd8q2y8">
          <div className="h-3 overflow-hidden border border-emerald-400/50 bg-[#09100b]" data-id="element-282" data-mp="1qva1nlallcpv">
            <div className="h-full w-[72%] bg-emerald-400" data-id="element-283" data-mp="2srl9shp3dvwj" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-284" data-mp="2xtixbo4izcva">
            <span className="text-emerald-300" data-id="element-285" data-mp="32q9g4j7psmke">
              Disponibilità limitata — solo per oggi
            </span>
            <span className="text-slate-300" data-id="element-286" data-mp="37kndus9un5s8">72% riscattato</span>
          </div>
        </div>
      </div>
    </section>;
}